export { default as TablesPage } from './Tables/tables';
export { default as TableDetailsPage } from './TableDetails/table-details';
export { default as TableUpdatePage } from './TableUpdate/table-update';
export { default as TableAnalyticsPage } from './TableAnalytics/table-analytics';
export { default as TableHandsPage } from './TableHands/table-hands';
export { default as TableSyncPage } from './TableSync/table-sync';
export { default as ContractSyncPage } from './ContractSync/contract-sync';
